"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@gibme/web-ui");
const balance_check_1 = require("./balance_check");
const key_generator_1 = __importDefault(require("./key_generator"));
const randomBigInt = require('random-bigint');
const min_page = BigInt(0);
const max_page = ((BigInt(2) ** BigInt(256)) - BigInt('432420386565659656852420866394968145537')) / BigInt(128);
const shorten = (text, lr = 6) => `${text.slice(0, lr)}...${text.slice(-lr)}`;
$(document).ready(() => {
    const { searchParams } = new URL(window.location.href);
    let page;
    if (searchParams.has('page')) {
        page = BigInt(searchParams.get('page') || '0');
    }
    if (page && page > max_page) {
        page = max_page;
    }
    const table = $('#key_list').dt({
        paging: false,
        searching: false,
        ordering: false,
        responsive: true,
        order: [[0, 'asc']],
        info: false,
        columnDefs: [{
                targets: [0],
                orderable: false,
                searchable: false,
                visible: false
            },
            {
                targets: [1],
                orderable: false,
                className: 'text-center',
                render: (record, type) => {
                    if (type === 'display') {
                        return $(`<div id="${record}">`)
                            .append($.createAwesomeIcon('spinner', { animation: 'spin-pulse' }))
                            .fullHTML();
                    }
                    return record;
                }
            },
            {
                targets: [3, 4, 5, 6, 7],
                orderable: false,
                render: (record, type) => {
                    if (type === 'display') {
                        return $(`<a id="${record}" target="_blank" ` +
                            `href="https://www.blockchain.com/explorer/addresses/btc/${record}">`)
                            .addClass('link-secondary')
                            .text(shorten(record))
                            .fullHTML();
                    }
                    return record;
                }
            }]
    }).draw()
        .columns.adjust()
        .responsive.recalc();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $('#key_card').on('ready', (_unusued, new_page) => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof new_page !== 'undefined') {
            page = BigInt(new_page);
        }
        else {
            page = undefined;
        }
        $.overlay('show', {
            text: {
                message: 'Generating Bitcoin Wallets...'
            },
            fade: {
                in: true,
                out: true
            },
            background: {
                className: 'bg-light'
            },
            progress: {
                value: 0,
                min: 0,
                max: 100
            }
        });
        yield $.sleep(1);
        table.clear().draw();
        const runs = [];
        $('#key_list').one('draw.dt', () => {
            $.overlay('hide');
            for (const run of runs) {
                run();
            }
        });
        const add_key = (index, private_key) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const key = key_generator_1.default.generate(private_key);
                const WIF = key.WIF;
                table.row.add([
                    index.toString(),
                    WIF,
                    key.WIF || '',
                    key.p2pkh || '',
                    key.compressed.p2pkh || '',
                    key.p2sh || '',
                    key.bech32 || '',
                    key.taproot || ''
                ]);
                runs.push(() => {
                    (0, balance_check_1.fetch_addresses)(key.addresses())
                        .then(addresses => {
                        let found = false;
                        for (const address of addresses) {
                            if (address.txs !== 0) {
                                found = true;
                                if (address.confirmed !== 0 || address.unconfirmed !== 0) {
                                    $(`#${address.address}`).removeClass('link-secondary')
                                        .addClass('link-success').parent().addClass('fa-shake');
                                }
                                else {
                                    $(`#${address.address}`).removeClass('link-secondary')
                                        .addClass('link-danger');
                                }
                            }
                        }
                        const elem = $(`#${WIF}`).empty();
                        if (found) {
                            $.createAwesomeIcon('check', { animation: 'bounce' })
                                .addClass('text-success')
                                .appendTo(elem);
                        }
                        else {
                            $.createAwesomeIcon('xmark')
                                .addClass('text-danger')
                                .appendTo(elem);
                        }
                    })
                        .catch(() => {
                        const elem = $(`#${WIF}`).empty();
                        $.createAwesomeIcon('triangle-exclamation')
                            .addClass('text-danger')
                            .appendTo(elem);
                    });
                });
            }
            catch (_a) { }
        });
        {
            let min = BigInt(0);
            if (page) {
                min = page * BigInt(128);
            }
            const max = min + BigInt(128);
            const progress = (i) => Math.ceil((i / 128) * 100);
            for (let i = (min + BigInt(1)), j = 1; i <= max; i++, j++) {
                yield add_key(i, typeof page !== 'undefined' ? i : undefined);
                yield $.sleep(0.1);
                $.overlay('progress', progress(j));
            }
            table.draw().columns.adjust().responsive.recalc();
        }
    })).trigger('ready', [page === null || page === void 0 ? void 0 : page.toString()]);
    $('.random_page').on('click', () => {
        let page = randomBigInt(256) / BigInt(128);
        if (page > max_page) {
            page = max_page;
        }
        searchParams.set('page', page.toString());
        window.location.href = `?${searchParams.toString()}`;
    });
    $('.previous_page').on('click', () => {
        page !== null && page !== void 0 ? page : (page = BigInt(0));
        let back = page - BigInt(1);
        if (back < min_page) {
            back = min_page;
        }
        searchParams.set('page', back.toString());
        window.location.href = `?${searchParams.toString()}`;
    });
    $('.next_page').on('click', () => {
        page !== null && page !== void 0 ? page : (page = BigInt(-1));
        let fwd = page + BigInt(1);
        if (fwd > max_page) {
            fwd = max_page;
        }
        searchParams.set('page', fwd.toString());
        window.location.href = `?${searchParams.toString()}`;
    });
    $('.last_page').on('click', () => {
        searchParams.set('page', max_page.toString());
        window.location.href = `?${searchParams.toString()}`;
    });
    $('.first_page').on('click', () => {
        searchParams.set('page', '0');
        window.location.href = `?${searchParams.toString()}`;
    });
});
